import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import TextInput from "../../../../../../merchant/panel/scripts/shared/input/textinput.js";
import ProcessingAnimation from "../../../../../../merchant/panel/scripts/shared/ProcessingAnimation/ProcessingAnimation.js";
import { get } from "../../../../modules/get.js";
import executeRequest from "../../../../modules/request.js";
import Button from "../../../../shared/ui/inputs/classicButton.js";
import { updateStyle } from "../../../client/gallery/scripts/useStyle.js";
import "./style.css";
import Consents from "../../../client/components/consents/consents.js";
export default function LiveLoginSiteMain(props) {
    const [data, setData] = useState();
    const { siteName } = useParams();
    const [params, setParams] = useSearchParams();
    const galleryName = params.get("g");
    const [groupName, setGroupName] = useState("");
    const [errorMsg, setErrorMsg] = useState(undefined);
    const [consents, setConsents] = useState(undefined);
    useEffect(() => {
        get(`/api/c/${siteName}/data`).then((res) => {
            setData(res);
        });
    }, []);
    if (!data)
        return React.createElement(ProcessingAnimation, null);
    if (data.status !== 200)
        return React.createElement(React.Fragment, null, "Nieprawid\u0142owe rz\u0105danie");
    const { data: content } = data;
    updateStyle(content === null || content === void 0 ? void 0 : content.style, "default");
    async function loginToGallery() {
        const response = await executeRequest(`/api/public/users/gallery/open?link=${galleryName}&liveGroupName=${groupName}`, "GET", {});
        if (response.status !== 200) {
            setErrorMsg("Takiej grupy jeszcze nie ma!");
            return;
        }
        setConsents(response.consents);
    }
    return (React.createElement("main", { className: "live-login-site-main" }, consents === undefined ?
        React.createElement(React.Fragment, null,
            React.createElement("h3", null,
                "Galeria: ",
                galleryName),
            React.createElement(TextInput, { label: "Podaj nazw\u0119 grupy (klasy)", placeholder: "np. 1a", classNames: "live-login-site-input", value: groupName, onChange: setGroupName }),
            React.createElement(Button, { onClick: () => loginToGallery() }, "Wejd\u017A do galerii"),
            errorMsg && React.createElement("span", { style: { color: "red" } }, errorMsg))
        : React.createElement(React.Fragment, null,
            React.createElement(Consents, { consents: consents }))));
}
